import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  RecordRevenueModal,
  RevenueTable,
  UpdateRevenueModal
} from "../components";
import { MakeReveneVoidModal } from "../components/Modals/MakeReveneVoidModal";
import { useRevenueStore } from "../store";

export const Revenue = () => {
  const [revenueRecord, setRevenueRecord] = useState(null);
  const [makeReveneVoidModalOpen, setMakeReveneVoidModalOpen] = useState(false);

  const openRecordRevenueModal = useRevenueStore(
    state => state.openRecordRevenueModal
  );

  const { hash } = useLocation();

  useEffect(() => {
    if (hash === "#record-revenue") {
      openRecordRevenueModal();
    }
  }, [hash, openRecordRevenueModal]);

  return (
    <>
      <RecordRevenueModal />
      <UpdateRevenueModal
        data={revenueRecord}
        openReveneVoidModal={() => setMakeReveneVoidModalOpen(true)}
      />
      <RevenueTable onEdit={record => setRevenueRecord(record)} />
      <MakeReveneVoidModal
        open={makeReveneVoidModalOpen}
        onClose={() => setMakeReveneVoidModalOpen(false)}
        revenueId={revenueRecord?.id || ""}
      />
    </>
  );
};
